export default "__VITE_ASSET__77f76743__"